module.exports = __webpack_public_path__ + "img/fincor_clear.07cffd37.png";